module.exports = __webpack_public_path__ + "img/dg6.295693c8.jpg";